import PropTypes from 'prop-types'
import classNames from 'classnames'

import Title from 'components/Title'
import PostItem from 'components/PostItem'
import Link from 'components/Link'

import s from './ShowcaseBlock.module.css'

function ShowcaseBlock({ showcase, className }) {
  if (!showcase) return null

  const {
    // TODO: No longer needed in graphql
    // acfShowcaseSettings: { boardLink },
    acfShowcases: { showcaseTitle, link, subtitle, showcasesGrid },
  } = showcase
  const setTitle = showcaseTitle ? showcaseTitle.split('\n') : null

  return (
    <div className={classNames(s.container, className)}>
      <div className={s.wrapper}>
        <div className={s.header}>
          {setTitle && (
            <Title
              title={setTitle[0]}
              subtitle={setTitle[1] || null}
              borderTitle
              lightSubtitle
            />
          )}
          {link && subtitle && (
            <Link className={s.link} href={link.slug} type={link.__typename}>
              {subtitle}
            </Link>
          )}
        </div>
        <div className={s.showcases}>
          {showcasesGrid?.map(({ image, model, brand, publication }) => {
            if (!model?.slug) return null
            const slug = model.slug
            const title = model.title
            return (
              <Link key={slug} className={s.showcase} href={slug} type="Model">
                <PostItem
                  image={image?.mediaItemUrl}
                  title={title}
                  brand={brand?.[0]?.name}
                  publication={publication?.[0]?.name}
                  lightUi
                />
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

ShowcaseBlock.propTypes = {
  showcase: PropTypes.object,
  className: PropTypes.string,
}
ShowcaseBlock.defaultProps = {
  showcase: {},
  className: '',
}

export default ShowcaseBlock
